import React, { useContext, useEffect } from "react";
import FileSaver from "file-saver";
import { withRouter } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import PublishOutlinedIcon from "@material-ui/icons/PublishOutlined";
import AlertMui from "../core/AlertMui";

import RcofHistoryTable from "./RcofHistoryTable";
import useMediaQuery from "../../hooks/useMediaQuery";

import AlertContext from "../../context/alert/alertContext";
import AuthContext from "../../context/authentication/authContext";
import TableContext from "../../context/table/tableContext";

const useStyles = makeStyles((theme) => ({
  containerTabs: {
    margin: "auto",
    textAlign: "center",
  },
  tabs: {
    marginLeft: "30px",
    color: "#707070",
    "&:hover": {
      color: "#12b1ee !important",
      borderBottom: "solid 1px #12b1ee;",
    },
  },
}));

const RcofHistoryTables = (props) => {
  const authContext = useContext(AuthContext);
  const { closeSession, authenticatedUser } = authContext;
  const tableContext = useContext(TableContext);
  const alertContext = useContext(AlertContext);
  const {
    data,
    currentPage,
    totalPages,
    getRcofHistoryData,
    setTransactionTable,
    setShiftClosuresTable,
    setRcofHistoryTable,
    rcofHistoryTable,
    filters,
    removeFilters,
    error,
    maxPerPage,
    setMaxPerPage,
  } = tableContext;

  const { alert, showAlert } = alertContext;
  const classes = useStyles();


  useEffect(() => {
    authenticatedUser();
    getRcofHistoryData();
  }, [currentPage, filters, maxPerPage]);

  const toTransactions = (e) => {
    removeFilters();
    setTransactionTable();
    props.history.push("/app/transactions");
  };

  const toShiftClosures = (e) => {
    removeFilters();
    setShiftClosuresTable();
    props.history.push("/app/shift-closures");
  };

  const toRcofHistory = (e) => {
    removeFilters();
    setRcofHistoryTable();
    props.history.push("/app/rcof-history");
  };

  // const downloadFile = async () => {
  //   try {
  //     const response = await getExportFileShiftClosures();
  //     if (!response.status) {
  //       showAlert("Ha ocurrido un error con la descarga", "error");
  //     } else {
  //       showAlert("Archivo descargado", "success");
  //       return FileSaver.saveAs(response.csvData, "Reporte.csv");
  //     }
  //     /* showAlert("Archivo descargado", "success"); */
  //   } catch (error) {
  //     showAlert("Ha ocurrido un error con la descarga", "error");
  //     /*   if(!error.status){
  //       showAlert("Ha ocurrido un error con la descarga", "error");
  //     } */
  //   }
  // };

  const isMobile = useMediaQuery("max-width", 600);

  const columnsRcofHistory = [
    {
      name: "Fecha",
    },
    {
      name: "Tracking Id",
    },
    {
      name: "Cantidad de boletas",
    },
    {
      name: "Total boletas Afectas",
    },
    {
      name: "Total boletas exentas",
    },
    {
      name: "Total",
    },
    {
      name: "",
    },
  ];

  if (error) {
    props.history.push("/app/error");
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={!isMobile ? 8 : 10} className={classes.containerTabs}>
          <span
            name="historicalTransactions"
            style={{
              // marginLeft: "30px",
              /*  color: showHistoricalTransactions ? "#12b1ee" : "#707070",
              borderBottom: showHistoricalTransactions
                ? "solid 1px #12b1ee"
                : "", */
              cursor: "pointer",
            }}
            onClick={toTransactions}
          >
            Transacciones Históricas
          </span>
          <span
            name="closesZ"
            style={{
              marginLeft: "30px",
              // color: shiftClosuresTable ? "#12b1ee" : "#707070",
              // borderBottom: shiftClosuresTable ? "solid 1px #12b1ee" : "",
              cursor: "pointer",
            }}
            onClick={toShiftClosures}
          >
            Cierre TRX
          </span>
          <span
            name="rcofHistory"
            style={{
              marginLeft: "30px",
              color: rcofHistoryTable ? "#12b1ee" : "#707070",
              borderBottom: rcofHistoryTable ? "solid 1px #12b1ee" : "",
              cursor: "pointer",
            }}
            onClick={toRcofHistory}
          >
            RCOF Históricos
          </span>
        </Grid>
        {/* <Grid item xs={!isMobile ? 4 : 2}>
          {!isMobile && !alert ? (
            <Button
              variant="contained"
              startIcon={<PublishOutlinedIcon />}
              style={{
                backgroundColor: "#6100ed",
                color: "#ffffff",
                float: "right",
              }}
              onClick={downloadFile}
            >
              EXPORTAR DATOS
            </Button>
          ) : isMobile ? (
            <span>
              <SearchOutlinedIcon
                style={{ color: "#707070" }}
                position="end"
              ></SearchOutlinedIcon>
            </span>
          ) : (
            <AlertMui message={alert.msg} type={alert.category} />
          )}
        </Grid> */}
      </Grid>
      <Grid item xs={12}>
        <RcofHistoryTable
          columns={columnsRcofHistory}
          data={data}
          totalPages={totalPages}
          maxPerPage={maxPerPage}
          setMaxPerPage={setMaxPerPage}
        />
      </Grid>
    </div>
  );
};

export default withRouter(RcofHistoryTables);
